import { User } from '@lemsar/auth/domains/models/user';
import { Institution } from '@lemsar/institution/domains/model/institution';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    29/11/2020
 */
export class Message {
    public id: string;
    public sender: User;
    public institution: Institution;
    public text: string;
    public read: boolean;
    public admin: boolean;
    public createdAt: Date;
    public updatedAt: Date;
}

export class CreateMessage {
    public text: string;
}



// WEBPACK FOOTER //
// ./src/lemsar/message/domains/model/message.ts